import React from "react";
import Modal from "react-modal";
import { connect } from "react-redux";
import { loadSession } from "../../redux/reducers/global-catalog.reducer";
import { cloneDeep } from "lodash";
import moment from 'moment';
import Loader from "../icons/tat/loader";
import Button from "../controls/button";
import TextInput from "../controls/text-input";
import { normalizeStr, sendMessageToMultipleUsersInSocket, showSimpleFlashNotification } from "../utils";
import Tag from "../controls/tag";
import ModalSelectInput from "../../control/shipment/modal-select-input";
import { createEntity, getEntityItems, readEntities } from "../../redux/api";
import ChangeDateModal from "./change-date-modal";
import { getUrlsEnv } from "../backend-api";
import ImageWithCheckMark from "../component/image-with-check-mark";
import { RecommendationError } from "../../control/orders/consolidate-trip-modal";
import { cancelMultipleRequests } from '../../redux/api/actions';

Modal.setAppElement("#root");

class ConfirmOrderModal extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      orders: cloneDeep(props.orders || []),
      tagsSelectorOpened: false,
      searchText: '',
      modifyAppointmentLoading: null,
      modifyAppointmentUnloading: null,

      newDateAppointmentLoading: null,
      newDateAppointmentUnloading: null,
      errorMessage: null,
      expeditionsClass: []
    }
  }

  componentDidMount () {
    document.addEventListener("mousedown", this.handleClick, false);
  }

  handleClick = (e) => {

    let list_items_to_exclude = [
      'plus',
      'field',
      'tag-body light',
      'tag-body dark',
      'tag-selector',
      'clean-filter',
      'items chips',
      'text-input  valid',
      'deselector'
    ];

    if (!list_items_to_exclude.includes(e.target.className) && this.state.tagsSelectorOpened) {

      this.setState({
        searchText: '',
        tagsSelectorOpened: false,
        errorMessage: null
      });

    }

  }

  componentWillUnmount(){
    document.removeEventListener("mousedown", this.handleClick, false);
  }

  onClose = () => {
    if (this.props.isLoading) return;
    if (this.props.closeAction) this.props.closeAction();
  };

  buildTitle = () => {
    let order = (this.state.orders.length > 0) ? this.state.orders[0] : null;
    if (order === null) return '';

    if (this.props.editTransportClass) {
      return(
        <>
          <div className="title-action">{this.props.editTransportClass === 1 ? `Clase de Expedición Proveedor de la Orden ${order.order_code}` : `Clase de Expedición Cliente de la Orden ${order.order_code}`}</div>
        </>
      );
    }

    return(
      <>
        <div className="title-action">{`Confirmar Orden ${order.order_code}`}</div>
      </>
    );
  }

  buildHeaders = () => {

    if (this.props.editTransportClass) {
      return(
        <div className="orders-content" style={{marginTop: 25}}> 
          <div className="order-row">
            <div className="order-item">{'Clase de Expedición'}</div>
            <div className="order-item">{'Tipo'}</div>
          </div>
        </div>
      );
    }

    return(
      <div className="orders-content" style={{marginTop: 25}}> 
        <div className="order-row">
          {/* <div className="order-item">{'Número de Orden'}</div> */}
          <div className="order-item">{'Cita de Carga'}</div>
          <div className="order-item">{'Cita de Descarga'}</div>
          <div className="order-item">{'Clase de Expedición'}</div>
          <div className="order-item">{'Etiqueta de Orden'}</div>
          <div className="order-item">{'Criticidad'}</div>
          <div className="order-item">{'Tipo'}</div>
        </div>
      </div>
    );
  }

  buildTagSelector = (index, tags) => {
    let tagsSelected = tags;

    return(
      <React.Fragment>
        <div className="deselector">
          <span className="clean-filter" onClick={() => this.setState({searchText: ''})}>
            Limpiar filtro
          </span>

          <img
            alt=""
            src="/images/close-gray.svg"
            style={{ cursor: "pointer", width: 14, height: 14 }}
            onClick={() => {
              this.setState({
                searchText: '',
                tagsSelectorOpened: false,
                errorMessage: null
              });
            }}/>
        </div>
        <div className="search-list">
          <TextInput
            value={this.state.searchText}
            label="Buscar"
            name="searchText"
            onChange={this.handleChange}
          />
        </div>
        <div className="items chips">
          {this.handleFilterListSearch(
            this.props.tagsCatalog,
            "title",
            this.state.searchText
          ).map((i) => (
            <Tag
              key={i.id}
              id={i.id}
              color={i.color || "3D77F7"}
              title={i.title}
              isFull={
                tagsSelected.find((s) => s.id.toString() === i.id.toString()) ? true : false
              }
              parentBackground={"light"}
              onClick={(e) => {

                if (tagsSelected.find((s) => s.id.toString() === e.target.id.toString())) {
                  this.state.orders[index].tags = tagsSelected.filter( s => s.id.toString() !== i.id.toString())
                  this.setState({});
                } else {
                  let new_tags = this.state.orders[index].tags || [];

                  new_tags.push(e.target.tag);
                  this.state.orders[index].tags = new_tags;
                  
                  this.setState({});
                }
              }}
            />
          ))}
        </div>
      </React.Fragment>
    );
  }

  handleFilterListSearch = (items, field, value = "") => {
    if(!value.length > 0) return items;

    let result = [];
    items.forEach(i => {
      if(normalizeStr(i[field] || "").includes(normalizeStr(value))){
        result.push(i)
      } else {
        if((i.items || []).length){
          let matches = i.items.filter(ii => normalizeStr(ii[field] || "").includes(normalizeStr(value)));
          if(matches.length){
            result.push({
              ...i,
              items: matches
            })
          } else {
            
          }
        }
      }
    })
    return result;
  }

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  getTransportClass = (order) => {

    if (order.transport_class) {
      return order.transport_class;
    }

    if ((this.props.currentCompany?.type?.id || 0) === 3) {

      if (this.props.editTransportClass) {
        if ((order?.from_facility?.company?.type_id || 0) === 3 && order.transport_class_provider && this.props.editTransportClass === 1) {
          return order.transport_class_provider;
        } else if ((order?.to_facility?.company?.type_id || 0) === 3 && order.transport_class_client && this.props.editTransportClass === 2) {
          return order.transport_class_client;
        }
      } else {
        if ((order?.from_facility?.company?.type_id || 0) === 3 && this.props.transactionType === 2) {
          return order.transport_class_provider;
        } else if ((order?.to_facility?.company?.type_id || 0) === 3 && this.props.transactionType === 1) {
          return order.transport_class_client;
        }
      }

    } else {
      if ((order.to_company?.id || 0) === this.props.companyId && order.transport_class_client) {
        return order.transport_class_client;
      } else if ((order.from_company?.id || 0) === this.props.companyId && order.transport_class_provider) {
        return order.transport_class_provider;
      }
    }

    return order.transport_class;

  }

  getTransportClassList = (order) => {

    let equipment_quantity = 0;

    if (order.transport_class_provider && order.transport_class_provider.equipment_quantity > 0) {
      equipment_quantity = order.transport_class_provider.equipment_quantity;
    } else if (order.transport_class_client && order.transport_class_client.equipment_quantity > 0) {
      equipment_quantity = order.transport_class_client.equipment_quantity;
    }

    if (equipment_quantity === 0) {
      return this.state.expeditionsClass;
    }

    return this.state.expeditionsClass.filter( item => item.equipment_quantity === equipment_quantity);
  }

  loadClassExpedition = (order) => {
    this.props.cancelMultipleRequests();
                      
    if ((this.props.company?.type?.id || 0) === 3) {

      let company_id = 0;
      let from_facility_company_type = order?.from_facility?.company?.type_id || 0;
      let to_facility_company_type = order?.to_facility?.company?.type_id || 0;

      if (this.props.editTransportClass) {
        if (from_facility_company_type === 3 && this.props.editTransportClass === 1) {
          company_id = order?.from_company?.id || 0
        } else if (to_facility_company_type === 3 && this.props.editTransportClass === 2) {
          company_id = order?.to_company?.id || 0
        } else {
          return;
        }
      } else {
        if (from_facility_company_type === 3 && this.props.transactionType === 2) {
          company_id = order?.from_company?.id || 0
        } else if (to_facility_company_type === 3 && this.props.transactionType === 1) {
          company_id = order?.to_company?.id || 0
        } else {
          return;
        }
      }

      this.props.readClassTags({
        company_id,
        isMultipleCancels: true
      }, {
        onSuccess: (response) => {
          this.setState({
            expeditionsClass: (response || []).map( item => ({id: item.id, label: item.code, value: String(item.id), equipment_quantity: item.equipment_quantity}))
          });
        }
      });

    } else {
      this.props.readClassTags({
        company_id: this.props.companyId,
        isMultipleCancels: true
      }, {
        onSuccess: (response) => {
          this.setState({
            expeditionsClass: (response || []).map( item => ({id: item.id, label: item.code, value: String(item.id), equipment_quantity: item.equipment_quantity}))
          });
        }
      });
    }
  }

  buildOrdersContent = () => {
    return(
      <div className="orders-content">
        {
          this.state.orders.length === 0 ? 
          <div
            style={{
              height: '45%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'end',
              fontSize: 18
            }}
          >{'No hay órdenes'}</div> : 
          (this.state.orders || []).map( (order, index) => {

            if (this.props.editTransportClass) {
              return(
                <>
                <div className="order-row with-hover" key={`order-row-${order.order_id}`}>
                  <div className="order-item">
                    <ModalSelectInput
                      isLoading={this.props.isExpeditionsClassLoading}
                      isSearchable={false}
                      isDisabled={false}
                      onChange={(a) => {

                        // if (`${a.equipment_quantity}` === '1') {
                        //   this.state.containersQuantity = {id: 1, label: '1', value: '1'};
                        // } else if (`${a.equipment_quantity}` === '2') {
                        //   this.state.containersQuantity = {id: 2, label: '2', value: '2'};
                        // }

                        // this.setState({[`${order.order_id}-transport-class`]: a})

                        let current_transport = null;
                        let warning_transport_class = false;

                        if ((order.to_company?.id || 0) === this.props.companyId && order.transport_class_client) {
                          current_transport = order.transport_class_client;
                        } else if ((order.from_company?.id || 0) === this.props.companyId && order.transport_class_provider) {
                          current_transport = order.transport_class_provider;
                        }

                        if (current_transport) {
                          warning_transport_class = current_transport.equipment_quantity !== a.equipment_quantity;
                        }

                        this.state.orders[index].transport_class = a;
                        this.state.orders[index].warningTransportClass = warning_transport_class;

                        this.setState({errorMessage: null});

                      }}
                      name="class"
                      placeholder="Clase de Expedición"
                      value={this.getTransportClass(order)}
                      options={this.state.expeditionsClass}
                      onMenuClose={ () => {
                        this.setState({
                          expeditionsClass: []
                        });
                      }}
                      onMenuOpen={() => {
                        this.loadClassExpedition(order);
                      }}
                    />
                  </div>
                  <div className="order-item">{order.type}</div>
                </div>
                <div
                  key={`order-row-${order.order_id}-2`}
                  style={{ lineHeight: "12px", fontSize: "12px", color: "#fb2b2b", marginTop: 8, visibility: order.warningTransportClass === true ? 'visible' : 'hidden' }}
                >
                  *La nueva clase difiere en idcs con la clase original.
                  Este cambio reiniciará todas las órdenes del viaje y se perderá toda la información generada hasta el momento y realizará ajustes en los cobros de créditos.
                </div>
                </>
              );
            }

            return(
              <>
              <div className="order-row with-hover" key={`order-row-${order.order_id}`}>
                {/* <div className="order-item">{`${order.order_code}`}</div> */}
                <div className="order-item">
                  {order.appointment_loading_date ? moment(order.appointment_loading_date).format('DD/MM/YYYY HH:mm') : '-'}
                  <img
                    alt=""
                    src="/images/edit.png"
                    style={{ cursor: "pointer", width: 18, height: 18, marginLeft: 10 }}
                    onClick={() => {

                      let data = {
                        code: order.order_code || '', 
                        logo: getUrlsEnv().files.concat(order.from_company?.logo?.substring(1) || ''),
                        maneuver: 'Carga',
                      }

                      order.index = index;
                      order.data = data;

                      this.setState({
                        modifyAppointmentLoading: order,
                        errorMessage: null
                      });

                    }}
                  />
                </div>
                <div className="order-item">
                  {order.appointment_unloading_date ? moment(order.appointment_unloading_date).format('DD/MM/YYYY HH:mm') : '-'}
                  <img
                    alt=""
                    src="/images/edit.png"
                    style={{ cursor: "pointer", width: 18, height: 18, marginLeft: 10 }}
                    onClick={() => {

                      let data = {
                        code: order.order_code || '', 
                        logo: getUrlsEnv().files.concat(order.to_company?.logo?.substring(1) || ''),
                        maneuver: 'Carga',
                      }

                      order.index = index;
                      order.data = data;

                      this.setState({
                        modifyAppointmentUnloading: order,
                        errorMessage: null
                      });

                    }}
                  />
                </div>
                <div className="order-item">
                  <ModalSelectInput
                    isLoading={this.props.isExpeditionsClassLoading}
                    isSearchable={false}
                    isDisabled={false}
                    onChange={(a) => {

                      // if (`${a.equipment_quantity}` === '1') {
                      //   this.state.containersQuantity = {id: 1, label: '1', value: '1'};
                      // } else if (`${a.equipment_quantity}` === '2') {
                      //   this.state.containersQuantity = {id: 2, label: '2', value: '2'};
                      // }

                      // this.setState({[`${order.order_id}-transport-class`]: a})

                      let current_transport = null;
                      let warning_transport_class = false;

                      if ((order.to_company?.id || 0) === this.props.companyId && order.transport_class_client) {
                        current_transport = order.transport_class_client;
                      } else if ((order.from_company?.id || 0) === this.props.companyId && order.transport_class_provider) {
                        current_transport = order.transport_class_provider;
                      }

                      if (current_transport) {
                        warning_transport_class = current_transport.equipment_quantity !== a.equipment_quantity;
                      }

                      this.state.orders[index].transport_class = a;
                      this.state.orders[index].warningTransportClass = warning_transport_class;

                      this.setState({errorMessage: null});

                    }}
                    name="class"
                    placeholder="Clase de Expedición"
                    value={this.getTransportClass(order)}
                    options={this.state.expeditionsClass}
                    onMenuClose={ () => {
                      this.setState({
                        expeditionsClass: []
                      });
                    }}
                    onMenuOpen={() => {
                      this.loadClassExpedition(order);
                    }}
                  />
                </div>
                <div className="order-item">
                  {(order.tags || []).map( item => item.title).join(', ')}

                  <div 
                    className="plus"
                    style={{marginLeft: 8, minWidth: 20}}
                    onClick={() => {
                      this.setState({
                        searchText: '',
                        tagsSelectorOpened: !this.state.tagsSelectorOpened,
                        errorMessage: null
                      });
                    }}
                  >{'+'}</div>
                  {
                    this.state.tagsSelectorOpened &&
                    <div className="tag-selector">
                      { this.buildTagSelector(index, order.tags || []) }
                    </div>
                  }
                </div>
                <div className="order-item">
                  <input
                    style={{textAlign: 'center'}}
                    className="text-input-custom"
                    name="level"
                    type="number"
                    value={order.criticality}
                    autocomplete={'off'}
                    onChange={(e) => {
                      this.state.orders[index].criticality = e.target.value;
                      this.setState({errorMessage: null});
                    }}
                    onBlur={(e) => {
                      let value = `${e.target.value}` !== '' ? parseInt(e.target.value) : 0;
                  
                      if (value < 1) {
                        this.state.orders[index].criticality = '';
                        this.setState({errorMessage: null});
                      }
                    }}
                  />
                </div>
                <div className="order-item">{order.type}</div>
              </div>
              
              <div
                key={`order-row-${order.order_id}-2`}
                style={{ lineHeight: "12px", fontSize: "12px", color: "#fb2b2b", marginTop: 8, visibility: order.warningTransportClass === true ? 'visible' : 'hidden' }}
              >
                *La nueva clase difiere en idcs con la clase original.
                Este cambio reiniciará todas las órdenes del viaje y se perderá toda la información generada hasta el momento y realizará ajustes en los cobros de créditos.
              </div>
              
              </>
            );
          })
        }
      </div>
    );
  }

  getDataToSave = () => {

    let order = (this.state.orders.length > 0) ? this.state.orders[0] : null;

    if (order === null) return {};

    let order_data = {
      company_id: this.props.companyId,
      action: 'confirm_order',
      order_id: order.order_id,
      appointment_loading: this.state.newDateAppointmentLoading,
      appointment_unloading: this.state.newDateAppointmentUnloading,
      tags: (order.tags || []).map( item => item.id),
      criticality: order.criticality,
      facility_id: this.props.transactionType === 1 ? order.to_facility.id : order.from_facility.id,
      last_facility: this.props.transactionType === 1 ? order.to_facility.id : order.from_facility.id
    };

    let transport_class = this.getTransportClass(order);

    if ((this.props.currentCompany?.type?.id || 0) === 3) {

      if (this.props.editTransportClass) {
        if ((order?.from_facility?.company?.type_id || 0) === 3 && this.props.editTransportClass === 1 && transport_class) {
          order_data.transport_class = transport_class.id;
        } else if ((order?.to_facility?.company?.type_id || 0) === 3 && this.props.editTransportClass === 2 && transport_class) {
          order_data.to_transport_class = transport_class.id;
        }
      } else {
        if ((order?.from_facility?.company?.type_id || 0) === 3 && this.props.transactionType === 2 && transport_class) {
          order_data.transport_class = transport_class.id;
        } else if ((order?.to_facility?.company?.type_id || 0) === 3 && this.props.transactionType === 1 && transport_class) {
          order_data.to_transport_class = transport_class.id;
        }
      }

    } else {

      if ((order.from_company?.id || 0) === this.props.companyId && transport_class) {
        order_data.transport_class = transport_class.id;
      } else if ((order.to_company?.id || 0) === this.props.companyId && transport_class) {
        order_data.to_transport_class = transport_class.id;
      }
    }

    return {
      company_id: this.props.companyId,
      action: 'confirm_order',
      orders: [order_data]
    };
  }

  buildActions = () => {
    return(
      <div className="actions" style={{marginTop: 35}}>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
          }}
        >
          <div/>

          <div style={{display: 'flex'}}>
            <Button
              disabled={this.props.isLoading}
              text={'Cerrar'}
              type={'btn secondary primary'}
              onClick={() => {
                this.onClose();
              }}
            />

            <div style={{width: 20}}/>

            <Button
              disabled={this.props.isLoading}
              text={this.props.isLoading ? <Loader circleColor={'black'}/> : 'Continuar' }
              type={'btn outline primary dark'}
              onClick={() => {

                if (this.props.editTransportClass) {
                  this.setState({
                    errorMessage: 'No hay webservice implementado, solo es front'
                  })
                  return;
                }

                this.props.callActionsOrder(this.getDataToSave(), { 
                  onSuccess: (response) => {

                    if (response.errors && response.errors.length > 0) {

                      this.setState({
                        errorMessage: response.errors.join(', ')
                      });

                    } else if (response.response_msg && response.response_msg.error && response.response_msg.error.length > 0) {

                      this.setState({
                        errorMessage: response.response_msg.error.join(', ')
                      });

                    } else if (response.notifications) {

                      try {
                        (response.notifications || []).map( item => {
                          sendMessageToMultipleUsersInSocket(
                            this.props.userId,
                            item['users'],
                            item['data']
                          );
                        });
                      } catch(e) {
                        console.log('error:', e)
                      }

                      showSimpleFlashNotification('Se realizó el cambio con éxito', null);
                      this.props.handleChange({
                        target: {
                          name: 'load_items'
                        }
                      });
                      this.onClose();

                    } else {
                      this.setState({
                        errorMessage: 'Ocurrió un error, intente de nuevo'
                      })
                    }
                  },
                  onError: (e) => {
                    this.setState({
                      errorMessage: e.response?.data?.error || 'Ocurrió un error, intente de nuevo'
                    })
                  }
                })


              }}
            />
          </div>
        </div>
      </div>
    );
  }

  buildFacilitiesInfo = () => {

    let order = (this.state.orders.length > 0) ? this.state.orders[0] : null;
    if (order === null) return '';

    let provider = order.from_company;
    let client = order.to_company;
    let from_facility = order.from_facility;
    let from_facility_company = order.from_facility?.company;
    let to_facility = order.to_facility;
    let to_facility_company = order.to_facility?.company;

    return(
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-around',
          marginTop: 15
        }}
      >

        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        > 
          
          <div style={{fontSize: 13, fontWeight: 'bolder'}}>{'Proveedor:'}</div>
          <div style={{display: 'flex', alignItems: 'center'}}>
            {
              provider ?
              <ImageWithCheckMark
                src={getUrlsEnv().files.concat(provider.logo?.substring(1) || '')}
                width={30}
                isCheckMark={provider.verification_status === 3}
                customStyle={{
                  width: 30, height: 30, borderRadius: '50%', position: 'relative', marginRight: 12, marginLeft: 18
                }}
                type={provider.type_id || 0}
              /> : <div/>
            }
            <div>{`${provider.orbi_id}`}</div>
          </div>

        </div>

        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        > 
          
          <div style={{fontSize: 13, fontWeight: 'bolder'}}>{'Cliente:'}</div>
          <div style={{display: 'flex', alignItems: 'center'}}>
            {
              provider ?
              <ImageWithCheckMark
                src={getUrlsEnv().files.concat(client.logo?.substring(1) || '')}
                width={30}
                isCheckMark={client.verification_status === 3}
                customStyle={{
                  width: 30, height: 30, borderRadius: '50%', position: 'relative', marginRight: 12, marginLeft: 18
                }}
                type={client.type_id || 0}
              /> : <div/>
            }
            <div>{`${client.orbi_id}`}</div>
          </div>

        </div>

        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        > 
          <div style={{fontSize: 13, fontWeight: 'bolder'}}>{'Origen:'}</div>
          <div style={{display: 'flex', alignItems: 'center'}}>
            {
              from_facility_company ?
              <ImageWithCheckMark
                src={getUrlsEnv().files.concat(from_facility_company.logo?.substring(1) || '')}
                width={30}
                isCheckMark={from_facility_company.verification_status === 3}
                customStyle={{
                  width: 30, height: 30, borderRadius: '50%', position: 'relative', marginRight: 12, marginLeft: 18
                }}
                type={from_facility_company.type_id || 0}
              /> : <div/>
            }

            <div>{`${from_facility.name}`}</div>
          </div>
        </div>

        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        > 
          <div style={{fontSize: 13, fontWeight: 'bolder'}}>{'Destino:'}</div>
          <div style={{display: 'flex', alignItems: 'center'}}>
            {
              to_facility_company ?
              <ImageWithCheckMark
                src={getUrlsEnv().files.concat(to_facility_company.logo?.substring(1) || '')}
                width={30}
                isCheckMark={to_facility_company.verification_status === 3}
                customStyle={{
                  width: 30, height: 30, borderRadius: '50%', position: 'relative', marginRight: 12, marginLeft: 18
                }}
                type={to_facility_company.type_id || 0}
              /> : <div/>
            }

            <div>{`${to_facility.name}`}</div>
          </div>

        </div>

      </div>
    );
  }

  render() {
    return (
      <Modal
        isOpen={this.props.orders !== null}
        portalClassName={`dialog confirm-order-dialog ${
          this.props.addClass ? this.props.addClass : ""
        }`}
        overlayClassName="overlay"
        className="content"
      >
        <div className="close" onClick={() => {
          this.onClose();
        }}></div>

        { this.buildTitle() }

        { this.buildFacilitiesInfo() }

        { this.buildHeaders() }
        { this.buildOrdersContent() }

        {
          this.state.errorMessage !== null &&
          <RecommendationError style={{marginTop: 20}}>
            {this.state.errorMessage}
          </RecommendationError>
        }

        { this.buildActions() }

        {
          this.state.modifyAppointmentLoading !== null && 
          <ChangeDateModal
            editDate={this.state.modifyAppointmentLoading.appointment_loading_date}
            open={this.state.modifyAppointmentLoading !== null}
            onClose={() => {
              this.setState({
                modifyAppointmentLoading: null
              });
            }}
            facilityId={this.state.modifyAppointmentLoading.from_facility.id}
            orderId={this.state.modifyAppointmentLoading.order_id}
            tripDetails={this.state.modifyAppointmentLoading.trip_details || []}
            data={this.state.modifyAppointmentLoading.data}
            date={new Date(this.state.modifyAppointmentLoading.appointment_loading_date)}
            reasons={this.props.orderMotives.filter((m) => m.type === 2)}
            getInfo={(info) => {
              this.state.orders[this.state.modifyAppointmentLoading.index].appointment_loading_date = info.date;
              this.setState({
                errorMessage: null,
                newDateAppointmentLoading: info
              })
            }}
          />
        }

        {
          this.state.modifyAppointmentUnloading !== null &&
          <ChangeDateModal
            editDate={this.state.modifyAppointmentUnloading.appointment_unloading_date}
            open={this.state.modifyAppointmentUnloading !== null}
            onClose={() => {
              this.setState({
                modifyAppointmentUnloading: null
              });
            }}
            facilityId={this.state.modifyAppointmentUnloading.to_facility.id}
            orderId={this.state.modifyAppointmentUnloading.order_id}
            tripDetails={this.state.modifyAppointmentUnloading.trip_details || []}
            data={this.state.modifyAppointmentUnloading.data}
            date={new Date(this.state.modifyAppointmentUnloading.appointment_unloading_date)}
            reasons={this.props.orderMotives.filter((m) => m.type === 2)}
            getInfo={(info) => {
              this.state.orders[this.state.modifyAppointmentUnloading.index].appointment_unloading_date = info.date;
              this.setState({
                newDateAppointmentUnloading: info
              })
            }}
          />
        }
        
      </Modal>
    );
  }
}

const mapStateToProps = (state) => {
  const companyId = state.globalCatalog.session.company.id;
  const expeditionsClass = (getEntityItems(state, "COMPANIES.TRANSPORTCLASS") || []).map( item => ({id: item.id, label: item.code, value: String(item.id), equipment_quantity: item.equipment_quantity}));
  const isOrdersLoading = state?.api['COMPANIES.REQUISITIONSCONTROL.ORDERS.ACTIONS']?.status?.isFetching || false;
  const isExpeditionsClassLoading = state?.api['COMPANIES.TRANSPORTCLASS']?.status?.isFetching || false;

  const orderMotives = getEntityItems(state, "COMPANIES.CATALOGS.ORDERSMOTIVES")
    .map((o) =>
      o.submotives.map((s) => ({
        label: `${o.description} - ${s.description}`,
        value: s.id,
        type: s.type,
      }))
    )
    .flat();

  return {
    userId: state.globalCatalog.session.user.id,
    orderMotives,
    companyId,
    // expeditionsClass,
    isLoading: isOrdersLoading,
    company: state.globalCatalog.session.company,
    isExpeditionsClassLoading
  };
}

const mapDispatchToProps = (dispatch) => {
  dispatch(loadSession());

  return {
    cancelMultipleRequests: () => dispatch(cancelMultipleRequests()),
    readClassTags: (params, opts) => dispatch(readEntities("COMPANIES.TRANSPORTCLASS", params, opts)),
    callActionsOrder: (params, opt) => dispatch(createEntity("COMPANIES.REQUISITIONSCONTROL.ORDERS.ACTIONS", params, opt)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmOrderModal);